
angular
    .module('TR')
    .directive('primaryNavigationList', function ($location : ng.ILocationService,
                                    broker: Core.Broker,
                                    scrollService,
                                     $route,
                                     $window,
                                     $document) {

        return {
            restrict: 'A',
            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery) {
                const navBarContentElement = $('#navbarcont');
                let isSlidePanel = (el.parents('.navigation-drawer').length === 1);
                if (isSlidePanel) {
                    // we are not showing sub menus in the navigation drawer yet,
                    // just publish the instruction to close the slide panel
                    el.find('a').click(
                        (e:any) => {
                            broker.publish('hideNavigationDrawer');
                        }
                    );
                    return;
                }

                let setStaticBar = () => {
                    navBarContentElement.addClass('static');
                };
                let unsetStaticBar = () => {
                    navBarContentElement.removeClass('static');
                };

                broker.subscribe('primaryNavigationList', 'bookingFormInitialised', setStaticBar);

                broker.subscribe('primaryNavigationList', 'bookingFormClosed', unsetStaticBar);

                let $listItemsWithSubMenus = el.find('> li.has-sub-menu');
                let $subMenuLinks = $listItemsWithSubMenus.find('.sub-menu a');

                if ($window.TRPCONFIG.IsTouchDevice) {

                    $listItemsWithSubMenus.find('> a').on('click',
                        (e: any) => {

                            let $link = $(e.currentTarget);
                            let $listItem  = $link.parent();

                            let isOpen = $listItem.hasClass('open');

                            if (isOpen) {

                                // let navigation execute and close menu
                                $listItem.removeClass('open');

                            } else {

                                // prevent link navigation and open the sub menu
                                e.preventDefault();

                                // close any other sub menus
                                $listItemsWithSubMenus.filter('.open').removeClass('open');

                                // open this sub menu
                                $listItem.addClass('open');

                                e.stopPropagation();

                                // close sub menu when anything else is clicked
                                $document.one('click.primaryNavigationList', (e2: any) => {

                                    // something else was clicked so close menu
                                    $listItem.removeClass('open');

                                });

                            }

                        }
                    );


                } else {

                    // apply "open" class on hover
                    let hoverTimeout:any = null;

                    $listItemsWithSubMenus.hover(
                        (e:any) => {
                            // hover action has a 200ms delay
                            hoverTimeout = setTimeout(() => {
                                $(e.currentTarget).addClass('open');
                            }, 200);
                        },
                        (e:any) => {
                            clearTimeout(hoverTimeout);
                            $(e.currentTarget).removeClass('open');
                        }
                    );

                    $listItemsWithSubMenus.find('a').one('click',
                        (e:any) => {
                            let $link = $(e.currentTarget);
                            $link.parent().removeClass('open');
                        }
                    );

                }

                // close sub menu on any sub menu link clicks
                $subMenuLinks.click(
                    (e:any) => {
                        let $link = $(e.currentTarget);
                        $link.parents('li.has-sub-menu').removeClass('open');
                    }
                );

                scope.$on('$destroy', () => {
                    $listItemsWithSubMenus.off();
                    $subMenuLinks.off();
                });

            }
        };
    });
